/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NotificationsContainerLocal = {
    readonly hasNewNotifications: boolean | null;
    readonly " $refType": "NotificationsContainerLocal";
};
export type NotificationsContainerLocal$data = NotificationsContainerLocal;
export type NotificationsContainerLocal$key = {
    readonly " $data"?: NotificationsContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"NotificationsContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNewNotifications",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '892684b3a7e48b66fff1eb86fe9575ba';
export default node;
